import { r as registerInstance, h, F as Fragment } from './index-16dc7dde.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import './product-card-6bb8cb81.js';
import { s as store } from './pes-router-store-1a105b49.js';
import './store-9d26336f.js';
import './utils-15ad90ec.js';
import { a as addHostToHmcUrls } from './utils-14261011.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './pick-bfea8c03.js';
import './_basePickBy-9e484e47.js';
import './identity-6651b537.js';
import './isSymbol-45bfef0c.js';
import './toString-da636857.js';
import './_assignValue-8e900715.js';
import './_isIndex-af307327.js';
import './hasIn-6ce0da41.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './index-136476ff.js';
import './request.constants-deb285e0.js';
import './lookups-705fb53e.js';
import './analytics-765d4daf.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './pes-product-link-b5153381.js';
import './utils-e67addce.js';
import './utils-2361a8f1.js';
import './index-634d378a.js';
import './tslib.es6-2af8cb53.js';
import './toNumber-5000b45d.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const pesAppSubcategoryCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.hmc-banner-container{display:block;margin:0 auto;padding:0 16px 20px;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;margin-top:42px;padding-bottom:0}.hmc-banner-container *,.hmc-banner-container *::before,.hmc-banner-container *::after{box-sizing:inherit}@media screen and (min-width: 980px){.hmc-banner-container{padding:0 10px}}@media screen and (min-width: 980px){.hmc-banner-container{margin-top:48px}}.subcategories__main{background-color:#fafafa}";

let PesAppSubcategory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.subcategoryData = null;
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  get customBreadcrumbs() {
    var _a, _b;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: this.subcategoryData
        && ((_b = (_a = this.subcategoryData.subcategoryBreadcrumbs) === null || _a === void 0 ? void 0 : _a.breadcrumbs) === null || _b === void 0 ? void 0 : _b.filter((breadcrumb) => {
          return !['SITE', 'BUSINESS'].includes(breadcrumb.itemType);
        })),
    };
  }
  get hmcBanner() {
    var _a;
    if (!((_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.hmcBanner)) {
      return {};
    }
    const { hmcBanner } = this.subcategoryData;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { subcategoryBreadcrumbs: { hideOnMobile }, subcategoryDescription: { name, description, readLessLabel, readMoreLabel }, subcategoryRanges: { rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, ranges, subCatagoryProductRangeLabel, avoidAccents, }, } = this.subcategoryData;
    const { sourceId, categoryName, parentCategoryId, hasQuestionnaire, categoryProductConfiguratorUrl, questionnaireUrl, rangeTooltipUrl, selectorConfigUrl, labels, } = this.hmcBanner;
    return (h(Fragment, null, h("div", { class: "subcategories__main" }, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: hideOnMobile, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs" }))), h("header", null, h("pes-category-description", { name: name, description: description, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel })), h("main", null, !isEmpty_1(this.hmcBanner) && (h("div", { class: "hmc-banner-container" }, h("pes-hmc-banner", { sourceId: sourceId, categoryName: categoryName, parentCategoryId: parentCategoryId, hasQuestionnaire: hasQuestionnaire, categoryProductConfiguratorUrl: categoryProductConfiguratorUrl, questionnaireUrl: questionnaireUrl, rangeTooltipUrl: rangeTooltipUrl, selectorConfigUrl: selectorConfigUrl, labels: labels, isPBS: true }))), h("pes-category-range-list", { rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, ranges: ranges, subCatagoryProductRangeLabel: subCatagoryProductRangeLabel, avoidAccents: avoidAccents }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { class: "pes-app-subcategory__section" }))))));
  }
};
PesAppSubcategory.style = pesAppSubcategoryCss;

export { PesAppSubcategory as pes_app_subcategory };
